<div class="mb-10 flex h-[60px] w-full items-center justify-center">
  <div class="flex h-full items-center justify-center rounded-lg border border-slate-100 p-1 px-1 shadow-xs">
    <app-logo class="block h-full" />
  </div>
  <span class="z-10 -mx-1 inline-flex rounded-full border border-slate-100 bg-white p-[0.2rem] text-gray-400 shadow-xs"
    ><IIcon name="linkRivet"
  /></span>
  <span class="h-full rounded-lg border border-slate-100 p-2 pr-[0.4rem] shadow-xs"
    ><img ngSrc="assets/img/amazon.svg" class="h-full w-auto" alt="" height="16" width="16"
  /></span>
</div>
